<template>
  <b-row class="justify-content-center">
    <b-col
      v-for="id in Array.from(Array(athletes.length).keys())"
      :key="id"
      :cols="3"
      :sm="3"
      md="auto"
      class="d-flex justify-content-center py-2"
    >
      <BaseAthleteScoreCircle
        :name="athletes[id].lastName"
        :score="athletes[id].round_score"
        :avatar="athletes[id].image"
      />
    </b-col>
    <b-col
      v-for="id in Array.from(Array(8 - athletes.length).keys())"
      :key="id + athletes.length"
      :cols="3"
      :sm="3"
      md="auto"
      class="d-flex justify-content-center py-2"
    >
      <BaseAthleteScoreCircle />
    </b-col>
  </b-row>
</template>

<script>
import BaseAthleteScoreCircle from '@/components/Atoms/BaseAthleteScoreCircle'
export default {
  name: 'TheAthletesPerformanceOverview',
  components: { BaseAthleteScoreCircle },
  props: {
    athletes: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style scoped>

</style>
